var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 12.8V1.6H7.2V7.2H12.8V8C13.36 8 13.896 8.104 14.4 8.28V4.8L9.6 0H1.6C0.712 0 0 0.712 0 1.6V12.8C0 13.68 0.712 14.4 1.6 14.4H8.28C8.104 13.896 8 13.36 8 12.8H1.6ZM8.8 1.2L13.2 5.6H8.8V1.2ZM16 12V13.6H13.6V16H12V13.6H9.6V12H12V9.6H13.6V12H16Z",
    fill: "#737373"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/AttachIcon.39b771f38c9e84a81388c89230ee06e8.svg";
export { ForwardRef as ReactComponent };